import { render, staticRenderFns } from "./reference-file.vue?vue&type=template&id=81e2085c&"
import script from "./reference-file.vue?vue&type=script&lang=js&"
export * from "./reference-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports